import React, { useContext } from "react";
import { FirebaseContext } from "../../../FirebaseContext";
import './Stages.css'; // Ensure you import the relevant CSS
import barbarianIcon from '../../../Images/classes/barbarian.svg';
import bardIcon from '../../../Images/classes/bard.svg';
import clericIcon from '../../../Images/classes/cleric.svg';
import druidIcon from '../../../Images/classes/druid.svg';
import fighterIcon from '../../../Images/classes/fighter.svg';
import monkIcon from '../../../Images/classes/monk.svg';
import paladinIcon from '../../../Images/classes/paladin.svg';
import rangerIcon from '../../../Images/classes/ranger.svg';
import rogueIcon from '../../../Images/classes/rogue.svg';
import sorcererIcon from '../../../Images/classes/sorcerer.svg';
import warlockIcon from '../../../Images/classes/warlock.svg';
import wizardIcon from '../../../Images/classes/wizard.svg';
import acolyteIcon from '../../../Images/backgrounds/acolyte.png';
import charlatanIcon from '../../../Images/backgrounds/charlatan.png';
import criminalIcon from '../../../Images/backgrounds/criminal.png';
import entertainerIcon from '../../../Images/backgrounds/entertainer.png';
import hermitIcon from '../../../Images/backgrounds/hermit.png';
import nobleIcon from '../../../Images/backgrounds/noble.png';
import sageIcon from '../../../Images/backgrounds/sage.png';
import sailorIcon from '../../../Images/backgrounds/sailor.png';
import soldierIcon from '../../../Images/backgrounds/soldier.png';
import artisanIcon from '../../../Images/backgrounds/artisan.png';
import farmerIcon from '../../../Images/backgrounds/farmer.png';
import wayfarerIcon from '../../../Images/backgrounds/wayfarer.png';
import merchantIcon from '../../../Images/backgrounds/merchant.png';
import guardIcon from '../../../Images/backgrounds/guard.png';
import guideIcon from '../../../Images/backgrounds/guide.png';
import scribeIcon from '../../../Images/backgrounds/scribe.png';
import aasimarIcon from '../../../Images/species/aasimar.png';
import dragonbornIcon from '../../../Images/species/dragonborn.png';
import dwarfIcon from '../../../Images/species/dwarf.png';
import elfIcon from '../../../Images/species/elf.png';
import gnomeIcon from '../../../Images/species/gnome.png';
import goliathIcon from '../../../Images/species/goliath.png';
import halflingIcon from '../../../Images/species/halfling.png';
import humanIcon from '../../../Images/species/human.png';
import orcIcon from '../../../Images/species/orc.png';
import tieflingIcon from '../../../Images/species/tiefling.png';

export const Stages = (props) => {
    const { currentStage, setCurrentStage } = props;
    const { characterJSON } = useContext(FirebaseContext);

    const classes = [
        { name: 'Barbarian', icon: barbarianIcon, disabled: true },
        { name: 'Bard', icon: bardIcon, disabled: true },
        { name: 'Cleric', icon: clericIcon, disabled: true },
        { name: 'Druid', icon: druidIcon, disabled: true },
        { name: 'Fighter', icon: fighterIcon, disabled: true },
        { name: 'Monk', icon: monkIcon, disabled: true },
        { name: 'Paladin', icon: paladinIcon, disabled: true },
        { name: 'Ranger', icon: rangerIcon, disabled: true },
        { name: 'Rogue', icon: rogueIcon, disabled: true },
        { name: 'Sorcerer', icon: sorcererIcon, disabled: true },
        { name: 'Warlock', icon: warlockIcon, disabled: true },
        { name: 'Wizard', icon: wizardIcon, disabled: false }
    ];

    const backgrounds = [
        { name: 'Acolyte', icon: acolyteIcon, disabled: false },
        { name: 'Artisan', icon: artisanIcon, disabled: false },
        { name: 'Charlatan', icon: charlatanIcon, disabled: false },
        { name: 'Criminal', icon: criminalIcon, disabled: false },
        { name: 'Entertainer', icon: entertainerIcon, disabled: false },
        { name: 'Farmer', icon: farmerIcon, disabled: false },
        { name: 'Guard', icon: guardIcon, disabled: false },
        { name: 'Guide', icon: guideIcon, disabled: false },
        { name: 'Hermit', icon: hermitIcon, disabled: false },
        { name: 'Merchant', icon: merchantIcon, disabled: false },
        { name: 'Noble', icon: nobleIcon, disabled: false },
        { name: 'Sage', icon: sageIcon, disabled: false },
        { name: 'Sailor', icon: sailorIcon, disabled: false },
        { name: 'Scribe', icon: scribeIcon, disabled: false },
        { name: 'Soldier', icon: soldierIcon, disabled: false },
        { name: 'Wayfarer', icon: wayfarerIcon, disabled: false }
    ];   

    const species = [
        { name: 'Aasimar', icon: aasimarIcon, disabled: false },
        { name: 'Dragonborn', icon: dragonbornIcon, disabled: false },
        { name: 'Dwarf', icon: dwarfIcon, disabled: false },
        { name: 'Elf', icon: elfIcon, disabled: false },
        { name: 'Gnome', icon: gnomeIcon, disabled: false },
        { name: 'Goliath', icon: goliathIcon, disabled: false },
        { name: 'Halfling', icon: halflingIcon, disabled: false }, 
        { name: 'Human', icon: humanIcon, disabled: false },  
        { name: 'Orc', icon: orcIcon, disabled: false },
        { name: 'Tiefling', icon: tieflingIcon, disabled: false }
    ];

    const getClass = () => {
        return classes.find(cls => cls.name === characterJSON.class) || null;
    };

    const getBackground = () => {
        return backgrounds.find(bg => bg.name === characterJSON.background) || null;
    };

    const getSpecies = () => {
        const speciesObj = species.find(spec => spec.name === characterJSON.species) || null;
        // Include subspecies if it exists
        return speciesObj ? {
            ...speciesObj,
            name: characterJSON.subspecies ? `${speciesObj.name}` : speciesObj.name,
            subspecies: characterJSON.subspecies // Store the subspecies for rendering
        } : null;
    };

    const StageButton = (props) => {
        const { title, onClick, isSelected, icon, name, subspecies } = props;

        return (
            <button
                className={`stage-button ${isSelected ? 'selected' : ''}`}
                onClick={onClick}
            >
                {icon && <img src={icon.icon} className="icon" alt={name} />} {/* Conditionally render icon */}
                <p>{icon ? name : title}</p> {/* Display name if icon exists, otherwise display title */}
                {subspecies && <p className="subspecies">({subspecies})</p>} {/* Display subspecies on a new line */}
            </button>
        );
    };

    return (
        <div className="content-wrapper-post-selection">
            <div className="character-grid">
                <StageButton 
                    title={"Class"}     
                    onClick={() => setCurrentStage("class")}  
                    isSelected={currentStage === "class"}
                    icon={getClass()} // Pass the class icon
                    name={characterJSON.class} // Pass the selected class name
                />  
                <StageButton 
                    title={"Origin"}
                    onClick={() => setCurrentStage("background")}
                    isSelected={currentStage === "background"}
                    icon={getBackground()} // Pass the background icon
                    name={characterJSON.background} // Pass the selected background name
                /> 
                <StageButton 
                    title={"Species"}
                    onClick={() => setCurrentStage("species")}  
                    isSelected={currentStage === "species"} 
                    icon={getSpecies()} // Pass the species icon
                    name={getSpecies()?.name || characterJSON.species} // Pass the updated species name with subspecies if available
                    subspecies={getSpecies()?.subspecies} // Pass the subspecies for rendering
                />
                <StageButton 
                    title={"Ability"}
                    onClick={() => setCurrentStage("ability")}
                    isSelected={currentStage === "ability"} 
                />
                <StageButton 
                    title={"Alignment"}               
                />
                <StageButton 
                    title={"Details"}              
                /> 
            </div>
        </div>
    );
};
